<template>
    <section class="section +bg-white">
        <div class="editorial">
            <div id="latest_articles">
                <h2 class="heading-secondary +heading-delta +pd-bottom-sm +border-bottom +border-gray-light"> Latest Articles </h2>
                <ul class="list-bare">
                    <cc-hub-article
                        v-for="(article, index) in articles"
                        :key="index"
                        :article="article"
                        :fastly-params="fastlyParams"
                    ></cc-hub-article>
                </ul>
            </div>
            <pagination
                :currentPage="currentPage"
                :totalPages="totalPages"
                :generateUrl="generateUrl"
            ></pagination>
        </div>
    </section>
</template>

<script>
import ccHubArticle from './cc-hub-article'
import pagination from '../../../common/pagination'

export default {
  props: {
    articles: { type: Array, required: true },
    totalPages: { type: String, required: true },
    currentPage: { type: String, required: true },
    fastlyParams: { type: String, required: true }
  },
  components: { ccHubArticle, pagination },
  methods: {
    generateUrl(page) {
      /**
       * @description We need to format the URL to add the trailing slash
       * to reduce the internal redirects from ../example to ../example/
       */
      const formatUrl = (url) => {
          return url.replace('?', '/?');
      };
      return page > 1
          ? `${formatUrl(route('cc.hub.new', { page }).url())}#latest_articles`
          : `${route('cc.hub.new').url()}/#latest_articles`
    }
  }
}
</script>
